import { Unit } from './unit';

export interface SalesUnit {
  unit: Unit;
  factor: number;
  ean: string;
}
